import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_ENDPOINT } from "../../../../../data/network/services/ApiEndpoint";
import secureStorage from "../../../../../services/secureStorage";
import { LoaderGif } from "../../../../../utility/constants/assetsManager";
import {
  SS_AUTH_TOKEN,
  SS_USER_HASH_ID,
} from "../../../../../utility/constants/secureStorageManager";
import { STATUS_CODE_200 } from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import CustomModal from "../../../../components/main_comps/custom_modal";
import CustomTabs from "../../../../components/main_comps/custom_tabs";
import BulkUploadTab from "./BulkUploadTab";
import PreviewTable from "./PreviewTable";
import axios from "axios";
import { useNavigate } from "react-router";
import ConfirmationModal from "../../../../components/main_comps/custom_modal/ConfirmationModal";

const BulkUpload = ({ onClickNext }) => {
  const [currentTab, setCurrentTab] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(0);
  const [previewData, setPreviewData] = useState([]);
  const [file, setFile] = useState("");
  const [programId, setProgramId] = useState("");
  const [resetBulk, setResetBulk] = useState("");
  const [showButton, setShowButton] = useState(true);
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);


  const tabs = [
    {
      name: "Bulk Payout",
      key: 0,
    },
  ];


  // Filter the clientSecret array based on the criteria
  const filteredData = clientSecret.filter(item => {
    console.log(item, "mappping")
    return (
      item.serviceType?.toUpperCase() === "PAYOUT" &&
      item.serviceProviderName?.toUpperCase() === "AXIS" &&
      item.mechanism?.toUpperCase() === "VAN" &&
      item.industryType?.toUpperCase() === "CORPORATE"
    );
  });

  // console.log("Filtered Data:", filteredData);
  const program_id = filteredData.map((item) => item.program);

  const navigate = useNavigate();

  // const onClickCallApi = () => {
  //   setLoading(true);

  //   const clientId = secureStorage.getItem(SS_USER_HASH_ID);
  //   const formdata = new FormData();
  //   formdata.append("file", file);
  //   formdata.append("batchFormat", currentTab === 1 ? "UPI" : "BANK_ACCOUNT");
  //   const token = secureStorage.getItem(SS_AUTH_TOKEN);
  //   fetch(
  //     API_ENDPOINT.base_url + "/payin/fn/api/v1/external/upi/bulk/transfer",
  //     {
  //       body: formdata,
  //       headers: {
  //         Authorization: "Bearer " + token,
  //         client_secret: clientId,
  //         program_id: programId,
  //       },
  //       method: "POST",
  //     }
  //   )
  //     .then((response) => response.json())
  //     .then((response) => {
  //       if (response.statusCode === STATUS_CODE_200) {
  //         enqueueSnackbar(response.message, {
  //           variant: "success",
  //         });
  //         setStep(0);
  //         setCurrentTab(0);
  //         setPreviewData([]);
  //         setResetBulk(true);
  //         setFile("");
  //       } else {
  //         enqueueSnackbar(response.message, {
  //           variant: "error",
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       enqueueSnackbar(err.message, {
  //         variant: "error",
  //       });
  //     })
  //     .finally((res) => {
  //       setLoading(false);
  //     });
  // };
  // console.log(filteredData, "programId");

  const validateTransfers = (previewData) => {
    const errors = [];

    previewData.forEach((item, index) => {
      // Validate amount
      if (!item.amount || isNaN(item.amount) || parseFloat(item.amount) <= 0) {
        errors.push(`Row ${index + 1}: Amount should be a positive value with two decimal places.`);
      }

      // Validate transferMode
      if (!item.transferMode || !["IMPS", "NEFT", "RTGS", "FT"].includes(item.transferMode)) {
        errors.push(`Row ${index + 1}: Transfer mode must be 'IMPS', 'NEFT', 'RTGS', or 'FT'.`);
      }

      // Validate beneficiary details
      if (!item.bankName || item.bankName.length < 1) {
        errors.push(`Row ${index + 1}: Bank name must not be empty.`);
      }
      if (!item.bankAccount || item.bankAccount.toString().length < 9 || item.bankAccount.toString().length > 18) {
        errors.push(`Row ${index + 1}: Bank account must be between 9 and 18 characters.`);
      }
      if (!item.ifsc || !/^[A-Za-z]{4}[A-Za-z0-9]{7}$/.test(item.ifsc)) {
        errors.push(`Row ${index + 1}: IFSC must be valid.`);
      }
      if (!item.name || item.name.length < 2 || item.name.length > 50 || !/^[a-zA-Z ]+$/.test(item.name)) {
        errors.push(`Row ${index + 1}: Name must be between 2 and 50 characters and contain only letters and spaces.`);
      }
      if (!item.email || !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(item.email)) {
        errors.push(`Row ${index + 1}: Email must be a valid email address.`);
      }
      if (!item.phone || !/^\d{10}$/.test(item.phone.toString())) {
        errors.push(`Row ${index + 1}: Phone must be a valid 10-digit number.`);
      }

      // Validate remarks (if provided)
      if (item.remarks && (item.remarks.length > 50 || !/^[A-Za-z0-9 ]{1,50}$/.test(item.remarks))) {
        errors.push(`Row ${index + 1}: Remarks must be less than 50 characters and contain only letters, numbers, and spaces.`);
      }
    });

    return errors;
  };

  const onClickCallApi = async (previewData) => {
    // Run validation
    const validationErrors = validateTransfers(previewData);
    if (validationErrors.length > 0) {
      validationErrors.forEach(error => enqueueSnackbar(error, { variant: "error" }));
      return; // Stop further execution if validation fails
    }

    // If validation passes, proceed with formatting and API call
    const data = JSON.stringify({
      transfers: previewData.map(item => ({
        amount: item.amount > 0 ? item.amount.toFixed(2) : null,
        transferMode: item.transferMode,
        beneDetails: {
          bankName: item.bankName,
          bankAccount: item.bankAccount.toString(),
          ifsc: item.ifsc,
          phone: item.phone.toString(),
          name: item.name,
          email: item.email
        },
        remarks: item.remarks,
        beneNote: item.beneNote,
        referenceId: item.referenceId || ""
      }))
    });

    const ss_id = secureStorage.getItem(SS_USER_HASH_ID);

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: API_ENDPOINT.axis_url + "/external/va/bulk/direct-transfer",
      headers: {
        'client_secret': ss_id,
        'program_id': program_id,
        'Content-Type': 'application/json'
      },
      data: data
    };

    try {
      const response = await axios.request(config);

      if (response?.status === 200 && response?.data?.statusCode === 200) {
        enqueueSnackbar("Transfer successful", { variant: "success" });
        navigate("/dashboard");
      } else {
        const errorMessage = response.data?.message || 'Transfer failed';
        enqueueSnackbar(`Error: ${errorMessage}`, { variant: "error" });
      }
    } catch (error) {
      if (error.response) {
        enqueueSnackbar(`Error: ${error.response.data.message || 'Transfer failed'}`, { variant: "error" });
      } else if (error.request) {
        enqueueSnackbar("No response from the server", { variant: "error" });
      } else {
        enqueueSnackbar(`Request error: ${error.message}`, { variant: "error" });
      }
    }
  };



  useEffect(() => {
    let payout = clientSecret.filter((obj) => obj.serviceType === "payin");
    if (payout?.length !== 0) {
      setProgramId(payout[0]?.program);
    }
  }, []);
  return (
    <div>
      <CustomTabs
        tabs={tabs}
        activeIndex={currentTab}
        passCurrentTab={(data) => {
          setCurrentTab(data);
          setStep(0);
          setPreviewData([]);
          setFile("");
        }}
      />
      {step === 0 ? (
        <BulkUploadTab

          passRawData={(data) => {
            console.log(data, "raw_data");
            setFile(data[0]);
          }}
          passUploadedData={(data) => {
            console.log(data, "uploaded_data");
            setPreviewData(data);
          }}
          onPreviewData={(data) => {
            setStep(data);
          }}
          // onClickNext={() => {
          //   onClickCallApi(previewData);  // Pass previewData explicitly
          // }}
          currentTab={currentTab}
          reset={resetBulk}
          changeReset={() => setResetBulk(false)}
        />
      ) : (
        <div
          style={{
            width: "100%",
            height: "100%",
            padding: "10px 20px",
          }}
        >
          <PreviewTable tableDetails1={previewData} currentTab={currentTab} />
        </div>
      )}

      {
        showButton && (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 20,
              padding: "0px 20px",
            }}
          >
            {/* <CustomButton
              title="Next"
              onClick={async () => {
                try {
                  console.log("previewData", previewData);

                  // Check if there's data in previewData
                  if (previewData.length > 0) {
                    // Call API and await the result
                    let data = await onClickCallApi(previewData);

                    // Log the result from the API call
                    console.log("API Response Data:", data);

                    // If the API call returns a successful response, hide the button
                    if (data) {
                      setShowButton(false); // This will hide the button if the API call is successful
                    }
                  }
                } catch (error) {
                  // Handle any errors during the process
                  console.error("Error in API call:", error);
                }
              }}
              styles={{
                width: "100%",
                maxWidth: "400px",
                minWidth: "300px",
                opacity: previewData.length > 0 ? 1 : 0.5,
              }}
              disabled={previewData.length > 0 ? false : true}
            /> */}
            <CustomButton
              title="Next"
              onClick={() => {
                if (previewData.length > 0) {
                  setOpenConfirmationModal(true); // Open confirmation modal
                }
              }}
              styles={{
                width: "100%",
                maxWidth: "400px",
                minWidth: "300px",
                opacity: previewData.length > 0 ? 1 : 0.5,
              }}
              disabled={previewData.length > 0 ? false : true}
            />
            {
              openConfirmationModal && (
                <ConfirmationModal
                  children={
                    <div style={{ lineHeight: 1.5 }}>
                      <p style={{ margin: "0 0 10px 0" }}>Are you sure you want to proceed with this file?</p>
                      <strong style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
                        {file.name}
                      </strong>
                    </div>
                  }
                  openConfirmModal={openConfirmationModal}
                  onPressOk={async () => {
                    setOpenConfirmationModal(false); // Close the modal
                    if (previewData.length > 0) {
                      await onClickCallApi(previewData); // Call the API
                    }
                    setShowButton(false); // Optionally hide the button if API call is successful
                  }}
                  onPressCancel={() => setOpenConfirmationModal(false)} // Close modal without action
                />

              )
            }
          </div>
        )
      }


      {loading && (
        <CustomModal
          headerTitle=""
          open={loading}
          onClose={() => {
            // setLoading(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
        >
          <div>
            <img
              src={LoaderGif}
              alt="Loader "
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default BulkUpload;
